// export const contentAPI = process.env.NODE_ENV === 'development' ? 'http://api.fg2.test/' : 'https://api.fg2exhibitions.com/';
export const contentAPI = 'https://api.fg2exhibitions.com/';

export const origin = 'https://fg2.coalesce.se';

export const urlRoots = ['am-editions.org', 'fg2.test'];

export const useLanguageURLRoots = false;
